/* eslint-disable no-nested-ternary */
import { Grid } from '@material-ui/core';
import React from 'react';
import styled, { css } from 'styled-components';
import { USER_STATUS } from '@constants/user';
import { mapStatus } from '@helpers';

const { VERIFY_EMAIL, UNSUBSCRIBE, APPROVED } = USER_STATUS;

const StyledStatus = styled.span(
  ({ status, theme, isMobile }) => css`
    background: ${status === VERIFY_EMAIL
      ? '#FFEEBF'
      : status === UNSUBSCRIBE
      ? '#FDE6E5'
      : '#D0ECC9'};
    border-radius: 4px;
    width: fit-content;
    height: 20px;
    padding: 5px;
    padding-left: ${status === APPROVED && '16px'};
    padding-right: ${status === APPROVED && '16px'};
    text-transform: uppercase;
    color: ${status === VERIFY_EMAIL
      ? theme.colors.ybrand700
      : status === UNSUBSCRIBE
      ? theme.colors.rbrand400
      : '#2C6424'};
    font-size: 10px;
    line-height: 13px;
    margin-left: ${isMobile ? '-75px' : '5px'};
    margin-top: ${isMobile && '28px'};
    display: ${isMobile && 'flex'};
    align-items: ${isMobile && 'center'};
    justify-content: ${isMobile && 'center'};
  `
);

export const UserStatus = ({ children, isMobile, className = '' }) => (
  <Grid id="user-status" item className={className}>
    <StyledStatus status={children} data-testid="pending-rol" isMobile={isMobile}>
      {mapStatus(children)}
    </StyledStatus>
  </Grid>
);
